import dateFormat from 'date-fns/format'
import isLastDayOfMonth from 'date-fns/is_last_day_of_month'
import _ from 'lodash'

export class Point {
  constructor(
    readonly value: number,
    private readonly lastAvailableAt: Date
  ) {}

  /**
   * 最終有効一時の文字鉄表現
   */
  get lastAvailableDate(): string {
    const format = isLastDayOfMonth(this.lastAvailableAt)
      ? 'YYYY年MM月末日'
      : 'YYYY年MM月DD日'

    return dateFormat(
      this.lastAvailableAt,
      format,
      { locale: 'ja' }
    )
  }

  toString(): string {
    return `${this.value}`
  }
}

export class PointList {
  static readonly empty: PointList = new PointList([])
  static valueOf(list: Point[]): PointList {
    return new PointList(list)
  }

  constructor(private readonly list: Readonly<Point[]>) {}

  get total(): number {
    return _.sum(
      this.list.map(p => p.value)
    )
  }

  get asArray(): Point[] {
    return [...this.list] // shallow copy
  }
}
